import { render } from "./BrandStyriaVerlag.vue?vue&type=template&id=ce28ef30"
import script from "./BrandStyriaVerlag.vue?vue&type=script&lang=ts"
export * from "./BrandStyriaVerlag.vue?vue&type=script&lang=ts"

import "./BrandStyriaVerlag.vue?vue&type=style&index=0&id=ce28ef30&lang=scss"
script.render = render

export default script